import { useUiTheme } from 'framework/uiTheme';
import React from 'react';
import { EmailFieldLayoutType, BaseFieldLayoutType } from '../../field';

const EmailFieldLayout: EmailFieldLayoutType = ({ value, label, ...props }) => {
  const { BaseFieldLayout } = useUiTheme<BaseFieldLayoutType>();

  const passedValue = value ? <a href={`mailto:${value}`}>{value}</a> : null;

  return <BaseFieldLayout {...props} value={passedValue} label={label} />;
};

export default EmailFieldLayout;
